module.exports = __webpack_public_path__ + "assets/1e694b9f72d5ca5cb36cd13fa200b640.mp4";